import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { config } from "../config/const";
import "./admin.css"; // Import the CSS file

const AdminPage = () => {
  const [stories, setStories] = useState([]);
  const [publicStories, setPublicStories] = useState([]);
  const [expandedStoryIds, setExpandedStoryIds] = useState([]); // Track expanded stories
  const [selectedStories, setSelectedStories] = useState({});
  const [selectedSection, setSelectedSection] = useState("pending"); // Track selected section

  useEffect(() => {
    const fetchPendingStories = async () => {
      try {
        const token = localStorage.getItem("idToken");
        const response = await axios.get(
          `${config.backend_url}/user/pending-stories`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setStories(response.data.pendingStories);
      } catch (error) {
        console.error("Error fetching pending stories:", error);
        if (error.response.data.message === "Unauthorized") {
          window.location.href = "/";
        }
      }
    };

    const fetchPublicStories = async () => {
      try {
        const email = localStorage.getItem("email");
        console.log(email);
        const response = await axios.get(
          `${config.backend_url}/user/getStoryPublic`,
          {
            params: {
              email: email,
            },
          }
        );
        console.log(response.data.stories);
        setPublicStories(response.data.stories);
      } catch (error) {
        console.error("Error fetching public stories:", error);
        if (error.response.data.message === "Unauthorized") {
          window.location.href = "/";
        }
      }
    };

    fetchPendingStories();
    fetchPublicStories();
  }, []);

  const toggleExpandStory = (storyId) => {
    setExpandedStoryIds((prevState) =>
      prevState.includes(storyId)
        ? prevState.filter((id) => id !== storyId)
        : [...prevState, storyId]
    );
  };

  const handleSelectChange = (storyId, checked) => {
    setSelectedStories((prev) => ({
      ...prev,
      [storyId]: checked,
    }));
  };

  const approveStory = async (storyId) => {
    const token = localStorage.getItem("idToken");
    try {
      await axios.post(
        `${config.backend_url}/user/approve-story`,
        { storyId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setStories(stories.filter((story) => story._id !== storyId));
    } catch (error) {
      console.error("Error approving story:", error);
    }
  };

  const deleteStory = async (storyId) => {
    const token = localStorage.getItem("idToken");
    try {
      await axios.post(
        `${config.backend_url}/user/reject-story`,
        {
          storyId: storyId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setStories(stories.filter((story) => story._id !== storyId));
    } catch (error) {
      console.error("Error deleting story:", error);
    }
  };

  const deletePublicStory = async (storyId) => {
    const token = localStorage.getItem("idToken");
    try {
      await axios.post(
        `${config.backend_url}/user/reject-story`,
        {
          storyId: storyId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setPublicStories(publicStories.filter((story) => story._id !== storyId));
    } catch (error) {
      console.error("Error deleting public story:", error);
    }
  };

  const approveSelectedStories = async () => {
    const token = localStorage.getItem("idToken");
    const selectedIds = Object.keys(selectedStories).filter(
      (storyId) => selectedStories[storyId]
    );
    try {
      for (let storyId of selectedIds) {
        await axios.post(
          `${config.backend_url}/user/approve-story`,
          { storyId },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }
      setStories(stories.filter((story) => !selectedIds.includes(story._id)));
    } catch (error) {
      console.error("Error approving stories:", error);
    }
  };

  const deleteSelectedStories = async () => {
    const selectedIds = Object.keys(selectedStories).filter(
      (storyId) => selectedStories[storyId]
    );
    const token = localStorage.getItem("idToken");
    try {
      for (let storyId of selectedIds) {
        await axios.post(
          `${config.backend_url}/user/reject-story`,
          {
            storyId,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }
      setStories(stories.filter((story) => !selectedIds.includes(story._id)));
    } catch (error) {
      console.error("Error deleting stories:", error);
    }
  };

  const deleteSelectedPublicStories = async () => {
    const selectedIds = Object.keys(selectedStories).filter(
      (storyId) => selectedStories[storyId]
    );
    const token = localStorage.getItem("idToken");
    try {
      for (let storyId of selectedIds) {
        await axios.post(
          `${config.backend_url}/user/reject-story`,
          {
            storyId,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }
      setPublicStories(
        publicStories.filter((story) => !selectedIds.includes(story._id))
      );
    } catch (error) {
      console.error("Error deleting public stories:", error);
    }
  };

  return (
    <div className="admin-container">
      <h1>Admin Dashboard</h1>
      <div className="section-toggle">
        <button
          onClick={() => setSelectedSection("pending")}
          className={selectedSection === "pending" ? "active" : ""}
        >
          Pending Stories
        </button>
        <button
          onClick={() => setSelectedSection("public")}
          className={selectedSection === "public" ? "active" : ""}
        >
          Public Stories
        </button>
      </div>

      {selectedSection === "pending" && (
        <>
          <h2>Pending Stories</h2>
          <table className="story-table">
            <thead>
              <tr>
                <th>Select</th>
                <th>Title</th>
                <th>Author</th>
                <th>Expand</th>
                <th>Approve</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {stories.map((story) => (
                <React.Fragment key={story._id}>
                  <tr>
                    <td>
                      <input
                        type="checkbox"
                        checked={!!selectedStories[story._id]}
                        onChange={(e) =>
                          handleSelectChange(story._id, e.target.checked)
                        }
                      />
                    </td>
                    <td>
                      <Link to={`/story/${story._id}`}>{story.title}</Link>
                    </td>
                    <td>{story.user?.name}</td>
                    <td>
                      <button
                        onClick={() => toggleExpandStory(story._id)}
                        className="expand-button"
                      >
                        {expandedStoryIds.includes(story._id)
                          ? "Hide Story"
                          : "Expand Story"}
                      </button>
                    </td>
                    <td>
                      <div className="bulk-actions">
                        <button
                          onClick={() => approveStory(story._id)}
                          className="approve-button"
                        >
                          Approve
                        </button>
                      </div>
                    </td>
                    <td>
                      <div className="bulk-actions">
                        <button
                          onClick={() => deleteStory(story._id)}
                          className="delete-button"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                  {expandedStoryIds.includes(story._id) && (
                    <tr>
                      <td colSpan="6">
                        <div className="story-content">
                          <p>{story.content}</p>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>

          <div className="bulk-actions">
            <button onClick={approveSelectedStories}>Approve Selected</button>
            <button onClick={deleteSelectedStories}>Delete Selected</button>
          </div>
        </>
      )}

      {selectedSection === "public" && (
        <>
          <h2>Public Stories</h2>
          <table className="story-table">
            <thead>
              <tr>
                <th>Select</th>
                <th>Title</th>
                <th>Author</th>
                <th>Expand</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {publicStories.map((story) => (
                <React.Fragment key={story._id}>
                  <tr>
                    <td>
                      <input
                        type="checkbox"
                        checked={!!selectedStories[story._id]}
                        onChange={(e) =>
                          handleSelectChange(story._id, e.target.checked)
                        }
                      />
                    </td>
                    <td>
                      <Link to={`/story/${story._id}`}>{story.title}</Link>
                    </td>
                    <td>{story.user?.name}</td>
                    <td>
                      <button
                        onClick={() => toggleExpandStory(story._id)}
                        className="expand-button"
                      >
                        {expandedStoryIds.includes(story._id)
                          ? "Hide Story"
                          : "Expand Story"}
                      </button>
                    </td>
                    <td>
                      <div className="bulk-actions">
                        <button
                          onClick={() => deletePublicStory(story._id)}
                          className="delete-button"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                  {expandedStoryIds.includes(story._id) && (
                    <tr>
                      <td colSpan="5">
                        <div className="story-content">
                          <p>{story.content}</p>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>

          <div className="bulk-actions">
            <button onClick={deleteSelectedPublicStories}>
              Delete Selected
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default AdminPage;
